module.exports = __webpack_public_path__ + "img/flow_s.1c544c6d.png";